module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.UserContext.UserType == 1) ? [_c('div', [_c('div', [_c('div', {
    staticClass: "underBox skypeAcc"
  }, [_c('el-carousel', {
    staticClass: "swiper-Wrapper",
    attrs: {
      "interval": 5000,
      "autoplay": "",
      "loop": true,
      "id": "el-carousel"
    }
  }, [_c('el-carousel-item', [_c('div', {
    staticClass: "accountExecutive skypeAcc accountExecutive2"
  }, [_c('div', {
    staticStyle: {
      "width": "200px",
      "margin": "0px 20px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "src": require("../assets/img/sitting2.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "20px 20px 20px 10px",
      "width": "75%"
    }
  }, [_c('div', {
    staticClass: "Hello"
  }, [_vm._v("\n                          Hi, " + _vm._s(_vm.UserContext.LastName) + " " + _vm._s(_vm.UserContext.FirstName) + ".\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "hellptext",
    staticStyle: {
      "line-height": "30px"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.gets('$我将通过视频展示如何使用我们平台.请点击"用户指南"进行学习')) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "flex-end"
    }
  }, [_c('div', {
    staticClass: "viewBTN",
    on: {
      "click": function($event) {
        return _vm.ToUserGuide()
      }
    }
  }, [_vm._v(_vm._s(_vm.gets("$用户指南")))])])])])]), _vm._v(" "), _c('el-carousel-item', [_c('div', {
    staticClass: "accountExecutive skypeAcc accountExecutive2"
  }, [_c('div', {
    staticStyle: {
      "padding": "20px 10px 20px 40px"
    }
  }, [_c('div', {
    staticClass: "Hello"
  }, [_vm._v("\n                          Hi, " + _vm._s(_vm.UserContext.LastName) + " " + _vm._s(_vm.UserContext.FirstName) + ".\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "hellptext"
  }, [_vm._v("\n                          " + _vm._s(_vm.gets("$欢迎来到Shipping Revolution。")) + "\n                          " + _vm._s(_vm.gets("$我们很高兴您在这里。")) + "\n                          " + _vm._s(_vm.gets("$我们为遍布整个供应链的电子商务卖家提供广泛的服务。")) + "\n                        ")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "viewBTN",
    on: {
      "click": function($event) {
        return _vm.ToSeeMore()
      }
    }
  }, [_vm._v(_vm._s(_vm.gets("$查看更多")))])])]), _vm._v(" "), _c('div', [_c('img', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "src": require("../assets/img/sitting-8.png"),
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('el-carousel-item', [_c('div', {
    staticClass: "accountExecutive skypeAcc accountExecutive2"
  }, [_c('div', {
    staticStyle: {
      "width": "200px",
      "margin": "0px 20px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("../assets/img/sitting2.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "20px 20px 20px 10px",
      "width": "75%"
    }
  }, [_c('div', {
    staticClass: "Hello"
  }, [_vm._v("\n                          Hi, " + _vm._s(_vm.UserContext.LastName) + " " + _vm._s(_vm.UserContext.FirstName) + ".\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "hellptext",
    staticStyle: {
      "line-height": "30px"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.gets('$我将通过视频展示如何使用我们平台.请点击"用户指南"进行学习')) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "flex-end"
    }
  }, [_c('div', {
    staticClass: "viewBTN",
    on: {
      "click": function($event) {
        return _vm.ToUserGuide()
      }
    }
  }, [_vm._v(_vm._s(_vm.gets("$用户指南")))])])])])]), _vm._v(" "), _c('el-carousel-item', [_c('div', {
    staticClass: "accountExecutive skypeAcc accountExecutive2"
  }, [_c('div', {
    staticStyle: {
      "padding": "20px 10px 20px 40px"
    }
  }, [_c('div', {
    staticClass: "Hello"
  }, [_vm._v("\n                          Hi, " + _vm._s(_vm.UserContext.LastName) + " " + _vm._s(_vm.UserContext.FirstName) + ".\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "hellptext"
  }, [_vm._v("\n                           " + _vm._s(_vm.gets("$欢迎来到Shipping Revolution。")) + "\n                          " + _vm._s(_vm.gets("$我们很高兴您在这里。")) + "\n                          " + _vm._s(_vm.gets("$我们为遍布整个供应链的电子商务卖家提供广泛的服务。")) + "\n                        ")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "viewBTN",
    on: {
      "click": function($event) {
        return _vm.ToSeeMore()
      }
    }
  }, [_vm._v(_vm._s(_vm.gets("$查看更多")))])])]), _vm._v(" "), _c('div', [_c('img', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "src": require("../assets/img/sitting-8.png"),
      "alt": ""
    }
  })])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "accountExecutive ExecutivePhone"
  }, [_c('div', {
    staticClass: "Hello"
  }, [_vm._v("\n                " + _vm._s(_vm.gets("$我的账户管理者")) + "\n              ")]), _vm._v(" "), (!_vm.UserContext.SaleLoginName == '') ? _c('div', [_c('div', {
    staticClass: "account"
  }, [_c('div', {
    staticClass: "skypeAcc",
    staticStyle: {
      "margin-top": "30px",
      "margin-bottom": "30px"
    }
  }, [_c('div', {
    staticClass: "userImg"
  }, [_vm._v(_vm._s(_vm.NameFirst))]), _vm._v(" "), _c('div', {
    staticClass: "userName"
  }, [_vm._v(_vm._s(_vm.UserContext.SaleLoginName))])])]), _vm._v(" "), _c('div', {
    staticClass: "account",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "skypeAcc",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "userName"
  }, [_vm._v(_vm._s(_vm.gets("$邮箱")) + ": " + _vm._s(_vm.UserContext.SaleEmail))])]), _vm._v(" "), _c('div', [_c('i', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.UserContext.SaleEmail),
      expression: "UserContext.SaleEmail",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: (_vm.onError),
      expression: "onError",
      arg: "error"
    }],
    staticClass: "el-icon-document-copy",
    staticStyle: {
      "cursor": "pointer"
    }
  })])])]) : _c('div', [_c('div', {
    staticClass: "noData-text"
  }, [_vm._v("\n                  " + _vm._s(_vm.gets("$您的客服正在路上")) + "\n                ")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "fourCard skypeAcc"
  }, [_c('div', {
    staticClass: "OrderData",
    on: {
      "click": function($event) {
        return _vm.toOrderList()
      }
    }
  }, [_c('div', {
    staticClass: "skypeAcc OrderData-title"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_vm._v("\n                    " + _vm._s(_vm.gets("$待处理")) + "\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "tooltipDiv"
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-data skypeAcc",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('img', {
    staticClass: "card_img",
    attrs: {
      "src": require("../assets/img/UNfulfill_icon.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.homePageData.countNum))])])]), _vm._v(" "), _c('div', {
    staticClass: "OrderData",
    on: {
      "click": function($event) {
        return _vm.toOrderList()
      }
    }
  }, [_c('div', {
    staticClass: "skypeAcc OrderData-title"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_vm._v("\n                     " + _vm._s(_vm.gets("$已发货")) + "\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "tooltipDiv"
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-data skypeAcc",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('img', {
    staticClass: "card_img",
    attrs: {
      "src": require("../assets/img/ShippedOrder_icon.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.homePageData.delivered))])])]), _vm._v(" "), _c('div', {
    staticClass: "OrderData",
    on: {
      "click": function($event) {
        return _vm.toMyPaidDetail()
      }
    }
  }, [_c('div', {
    staticClass: "skypeAcc OrderData-title"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_vm._v("\n                    " + _vm._s(_vm.gets("$账户余额")) + "\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "tooltipDiv"
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-data skypeAcc",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('img', {
    staticClass: "card_img",
    attrs: {
      "src": require("../assets/img/AccountBalance_icon.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.Me && _vm.Me.Account ? _vm.Me.Account.realBalance + '(' + (_vm.Me.Account.Currency.EnName) + ')' : '0'))])])]), _vm._v(" "), _c('div', {
    staticClass: "OrderData",
    on: {
      "click": function($event) {
        return _vm.toEarnings()
      }
    }
  }, [_c('div', {
    staticClass: "skypeAcc OrderData-title"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_vm._v("\n                    " + _vm._s(_vm.gets("$推广收益")) + "\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "tooltipDiv"
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-data skypeAcc",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('img', {
    staticClass: "card_img",
    attrs: {
      "src": require("../assets/img/InvitationEarnings_icon.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.homePageData.Balance) + " (USD)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "skypeAcc twoEcharts",
    staticStyle: {
      "justify-content": "space-between",
      "font-family": "Helvetica"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "64.7%",
      "background-color": "#fff"
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold",
      "color": "#000",
      "position": "absolute",
      "left": "7%",
      "top": "5%",
      "font-size": "18px",
      "z-index": "3"
    }
  }, [_vm._v("\n                 " + _vm._s(_vm.gets("$总销量")) + "\n                ")]), _vm._v(" "), _c('div', {
    ref: "chart",
    staticStyle: {
      "width": "100%",
      "height": "360px",
      "position": "relative"
    },
    attrs: {
      "id": "echartsLine"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "33%",
      "background-color": "#fff"
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold",
      "color": "#000",
      "position": "absolute",
      "left": "7%",
      "top": "5%",
      "font-size": "18px",
      "z-index": "3"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.gets("$费用明细")) + "\n                ")]), _vm._v(" "), _c('div', {
    ref: "chart2",
    staticStyle: {
      "width": "600px",
      "height": "360px"
    },
    attrs: {
      "id": "echartsBall"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "bottom-card skypeAcc"
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-title skypeAcc"
  }, [_c('div', [_vm._v(_vm._s(_vm.gets("$我的商店")))]), _vm._v(" "), _c('div', {
    staticClass: "copy-btn",
    on: {
      "click": function($event) {
        return _vm.toShopList()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-copy-document"
  }), _vm._v(" " + _vm._s(_vm.gets("$查看全部")))])]), _vm._v(" "), _c('div', {
    staticClass: "rowName skypeAcc"
  }, [_c('div', [_vm._v(_vm._s(_vm.gets("$商店链接")))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.gets("$店铺状态")))])]), _vm._v(" "), _c('div', {
    staticClass: "row-table",
    staticStyle: {
      "height": "77%"
    }
  }, _vm._l((_vm.shopList), function(i, index) {
    return _c('div', {
      key: index,
      staticClass: "skypeAcc rowPadding",
      staticStyle: {
        "padding": "18px 0"
      }
    }, [_c('div', {
      staticClass: "adress"
    }, [_vm._v(" " + _vm._s(i.ShopName) + " \n                      ")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-right": "5%"
      }
    }, [(i.ISConnect == 1) ? _c('i', {
      staticClass: "el-icon-success",
      staticStyle: {
        "color": "#00CC05",
        "font-size": "20px"
      }
    }) : _c('i', {
      staticClass: "el-icon-remove",
      staticStyle: {
        "color": "#FDCA0C",
        "font-size": "20px"
      }
    })])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-title skypeAcc"
  }, [_c('div', [_vm._v(_vm._s(_vm.gets("$新闻/公告")))]), _vm._v(" "), _c('div', {
    staticClass: "copy-btn",
    on: {
      "click": function($event) {
        _vm.showNewListDialog = true, _vm.toSearchSys_New2()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-copy-document"
  }), _vm._v("  " + _vm._s(_vm.gets("$查看全部")))])]), _vm._v(" "), _c('div', {
    staticClass: "rowName skypeAcc"
  }, [_c('div', [_vm._v(_vm._s(_vm.gets("$新闻列表")))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.gets("$日期")))])]), _vm._v(" "), _c('div', {
    staticClass: "row-table",
    staticStyle: {
      "height": "77%",
      "overflow-y": "scroll"
    }
  }, _vm._l((_vm.SearchSys_New), function(o) {
    return _c('div', {
      key: o.ID,
      staticClass: "skypeAcc rowPadding",
      staticStyle: {
        "padding": "20px 0px"
      }
    }, [_c('el-tooltip', {
      staticClass: "textHover",
      attrs: {
        "content": o.Title,
        "effect": "dark",
        "placement": "top-start"
      }
    }, [_c('div', {
      staticStyle: {
        "width": "75%",
        "overflow": "hidden",
        "text-overflow": "ellipsis",
        "white-space": "nowrap",
        "cursor": "pointer"
      }
    }, [_vm._v(_vm._s(o.Title))])]), _vm._v(" "), _c('div', {
      staticClass: "percent",
      staticStyle: {
        "margin-left": "10px",
        "font-size": "14px",
        "color": "#9C9D9E"
      }
    }, [_vm._v(_vm._s(o.OperatorTime))])], 1)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-title skypeAcc",
    staticStyle: {
      "align-items": "baseline"
    }
  }, [_c('div', {
    staticClass: "skypeAcc"
  }, [_c('div', {
    staticClass: "thirdCardNumber"
  }, [_vm._v(_vm._s(_vm.gets("$缺货")))]), _vm._v(" "), _c('div', {
    staticClass: "outOfStockNum"
  }, [_vm._v(_vm._s(_vm.InventoryList.CountNum))])]), _vm._v(" "), _c('div', {
    staticClass: "copy-btn",
    on: {
      "click": function($event) {
        return _vm.toOrderList()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-copy-document"
  }), _vm._v("  " + _vm._s(_vm.gets("$查看全部")))])]), _vm._v(" "), _c('div', {
    staticClass: "rowName skypeAcc"
  }, [_c('div', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.gets("$产品")))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "65%"
    }
  }, [_vm._v(_vm._s(_vm.gets("$产品名称")))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "23%"
    }
  }, [_vm._v(_vm._s(_vm.gets("$在途数量")))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "12%"
    }
  }, [_vm._v(_vm._s(_vm.gets("$缺货")))])]), _vm._v(" "), _c('div', {
    staticClass: "row-table",
    staticStyle: {
      "overflow-y": "scroll",
      "height": "75%"
    }
  }, _vm._l((_vm.InventoryList.Records), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "skypeAcc rowPadding"
    }, [(item.ProductUrl == null) ? _c('img', {
      staticStyle: {
        "width": "15%"
      },
      attrs: {
        "src": require("../assets/img/noIMG.png"),
        "alt": ""
      }
    }) : _c('img', {
      staticStyle: {
        "width": "15%"
      },
      attrs: {
        "src": item.ProductUrl,
        "alt": ""
      }
    }), _vm._v(" "), _c('el-tooltip', {
      staticClass: "stock",
      attrs: {
        "content": item.CnName + item.EnName,
        "effect": "dark",
        "placement": "top-start"
      }
    }, [_c('div', {
      staticClass: "stockTitle",
      staticStyle: {
        "text-overflow": "ellipsis",
        "overflow": "hidden",
        "display": "-webkit-box",
        "-webkit-line-clamp": "2",
        "line-clamp": "2",
        "-webkit-box-orient": "vertical",
        "cursor": "pointer"
      }
    }, [_vm._v("\n                    \n                        " + _vm._s(item.CnName) + _vm._s(item.EnName) + "\n                   \n                  ")])]), _vm._v(" "), _c('div', {
      staticClass: "percent stockNum",
      staticStyle: {
        "background": "#F2AA4A",
        "width": "10%",
        "height": "30px"
      }
    }, [_vm._v(_vm._s(item.CustomerQty))]), _vm._v(" "), _c('div', {
      staticClass: "percent stockNum",
      staticStyle: {
        "background": "#FAE1E2",
        "color": "#EA6654",
        "width": "10%",
        "height": "30px",
        "line-height": "30px",
        "text-align": "center",
        "border-radius": "5px"
      }
    }, [_vm._v(_vm._s(item.Quantity))])], 1)
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "app-container",
    staticStyle: {
      "display": "none"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('el-col', [_c('el-card', {
    staticClass: "box-card1"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('i', {
    staticClass: "el-icon-bell",
    staticStyle: {
      "cursor": "pointer",
      "margin-right": "10px",
      "color": "#409EFF",
      "font-size": "19px"
    }
  }), _vm._v(_vm._s(_vm.g('$新闻/公告')))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "padding": "3px 0"
    },
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.toSearchSys_New()
      }
    }
  }, [_vm._v(_vm._s(_vm.g('$刷新')))])], 1), _vm._v(" "), _vm._l((_vm.SearchSys_New), function(o) {
    return _c('div', {
      key: o.ID,
      staticClass: "text item clearfix"
    }, [_c('a', {
      staticStyle: {
        "float": "left"
      },
      on: {
        "click": function($event) {
          return _vm.ToNew(o.ID)
        }
      }
    }, [_c('span', {
      staticClass: "dot"
    }), _vm._v(" " + _vm._s(o.Title))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v(_vm._s(o.OperatorTime))])])
  })], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "newDialog",
    attrs: {
      "visible": _vm.showNewListDialog,
      "modal-append-to-body": true,
      "append-to-body": true,
      "width": "80%",
      "title": "News"
    },
    on: {
      "update:visible": function($event) {
        _vm.showNewListDialog = $event
      }
    }
  }, [_c('div', {
    staticClass: "newContent"
  }, [_c('div', {
    staticClass: "skypeAcc",
    staticStyle: {
      "align-items": "baseline"
    }
  }, [_c('div', {
    staticClass: "right-wrapper"
  }, [_c('div', {
    staticClass: "right-list-title skypeAcc"
  }, [_c('div', {
    staticStyle: {
      "width": "28%",
      "margin-left": "5%"
    }
  }, [_vm._v("Date")]), _vm._v(" "), _c('div', [_vm._v("Topic")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "390px",
      "overflow-y": "scroll"
    }
  }, _vm._l((_vm.SearchSys_New2), function(o, index) {
    return _c('div', {
      key: index,
      staticClass: "list-column skypeAcc",
      style: (_vm.selectNewsID == o.ID ? 'background-color: #F7F6F7;color: #B0B0B0;border-left: 5px solid #B5B4B5;' : 'background-color: #fff;color: #606266;border-left: 5px solid #fff;'),
      on: {
        "click": function($event) {
          return _vm.GetSys_New(o.ID)
        }
      }
    }, [_c('div', {
      staticClass: "writeDate"
    }, [_vm._v(_vm._s(o.OperatorTime))]), _vm._v(" "), _c('div', {
      staticClass: "writeTitle"
    }, [_vm._v(_vm._s(o.Title))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "55%",
      "margin-left": "5%",
      "margin-bottom": "5%"
    }
  }, [_c('div', {
    staticClass: "left-wrapper"
  }, [_c('div', {
    staticClass: "left-title"
  }, [_vm._v("\n                            " + _vm._s(_vm.newsDetail.Title) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "left-date"
  }, [_vm._v("\n                          " + _vm._s(_vm.newsDetail.CreateTime) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "left-content",
    domProps: {
      "innerHTML": _vm._s(_vm.newsDetail.Content)
    }
  })])])])])])] : _c('order-list')], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "userImg",
    staticStyle: {
      "background-color": "#fff"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "38px"
    },
    attrs: {
      "src": require("../assets/img/email.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5cd13235"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/frame/Index.vue
// module id = 1287
// module chunks = 169